<template>
  <div>
    <div>
      <vue-dropzone id="dropzone-gallery"
                    ref="dropzone"
                    class="mb-3"
                    @vdropzone-sending="sendingEvent"
                    @vdropzone-success="moveUploadedFile"
                    :options="dropzoneOptions"></vue-dropzone>
    </div>
    <div class="row">
      <le-loading v-if="isLoading"></le-loading>
      <div class="col-sm-6 offset-sm-3" v-if="!photos.length && !isLoading">
        <h4 class="text-center mt-5 alert alert-warning">
          {{$t('game.no-photos-found')}}
        </h4>
      </div>
      <div v-for="(photo, photoIndex) in photos" :key="photo.uuid" class="col-sm-12 col-md-6 col-lg-4 col-xl-2 animated fadeIn mb-4" style="cursor: pointer" @click="editPhoto(photo, photoIndex)">
        <div class="options-container fx-item-rotate-r mb-1">
          <img class="img-fluid options-item" :src="photo.coverUrl" :id="`photo-cover-${photo.uuid}`" alt="">
          <div class="options-overlay bg-black-75">
            <div class="d-flex text-white font-weight-bold">
              {{$tc('tag.add', 2)}}
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <button class="btn btn-sm btn-info">
            <i class="fa fa-plus"></i> {{$tc('tag.add', 2)}}
          </button>
          <button class="btn btn-sm btn-danger" @click.stop="deletePhoto(photo, photoIndex)">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
    </div>
    <modal @before-close="modalClosed()" name="tags" :adaptive="true" class="bg-white" height="100%" width="100%">
      <div v-if="photoTagsLoading" style="height: 100%" class="position-relative">
        <le-loading></le-loading>
      </div>
      <div v-show="!photoTagsLoading" style="height: 100%" class="position-relative">
        <div class="d-flex justify-content-between text-right p-2 position-sticky gallery-modal-header">
          <div>
            <button :disabled="this.currentPhotoIndex < 1" @click="prevPhoto()" class="btn btn-sm btn-info mr-2"><i class="fa fa-arrow-left"></i></button>
            <button :disabled="this.photos.length - 1 <= this.currentPhotoIndex" @click="nextPhoto()" class="btn btn-sm btn-info"><i class="fa fa-arrow-right"></i></button>
          </div>
          <div>
            <button class="btn btn-sm mr-2" :class="isHighlighted(currentPhoto) ? 'btn-warning active' : 'btn-outline-warning'" @click.stop="toggleHighlight()" :title="$t ? $t('photo.highlight') : 'Highlight'">
              <i :class="isHighlighted(currentPhoto) ? 'fa fa-star' : 'fa fa-star-o'"></i>
            </button>
            <button class="btn btn-sm btn-danger" @click="$modal.hide('tags')">
              <i class="fa fa-close"></i>
            </button>
          </div>
        </div>
        <div v-if="entityOptions" class="px-4 pb-3">
          <div class="d-flex justify-content-around align-items-center mb-3">
            <button :disabled="rotatePhotoLoading" class="btn btn-sm btn-info" @click="rotatePhoto('left')"><i class="fa fa-undo"></i></button>
            <div class="position-relative">
              <le-loading v-if="rotatePhotoLoading"></le-loading>
              <img class="mw-100 px-2" style="max-height: 300px" :src="currentPhoto?.url" :id="`photo-${currentPhoto?.uuid}`" alt="">
            </div>
            <button :disabled="rotatePhotoLoading" class="btn btn-sm btn-info" @click="rotatePhoto('right')"><i class="fa fa-undo gallery-rotate-right-icon"></i></button>
          </div>
          <div class="d-flex mb-3 justify-content-center">
            <button class="btn btn-sm" :class="isHighlighted(currentPhoto) ? 'btn-warning active' : 'btn-outline-warning'" @click.stop="toggleHighlight()" :title="$t ? $t('photo.highlight') : 'Highlight'">
              {{$t('showPhotoInGallery')}} <i :class="isHighlighted(currentPhoto) ? 'fa fa-star' : 'fa fa-star-o'"></i>
            </button>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="mb-4">
                <le-photo-tag-entity :entity="entityOptions.homeTeam.entity" :is-active="isEntitySelected(entityOptions.homeTeam.entity)" @entityClicked="toggleEntity(entityOptions.homeTeam.entity)"></le-photo-tag-entity>
              </div>
              <div class="row">
                <div v-for="player in entityOptions.homeTeam.players" :key="player.entity.entityUuid" class="col-lg-6">
                  <le-photo-tag-entity :entity="player.entity" :circle-info="player.jerseyNumber" :is-active="isEntitySelected(player.entity)" @entityClicked="toggleEntity(player.entity)"></le-photo-tag-entity>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="mb-4">
                <le-photo-tag-entity :entity="entityOptions.awayTeam.entity" :is-active="isEntitySelected(entityOptions.awayTeam.entity)" @entityClicked="toggleEntity(entityOptions.awayTeam.entity)"></le-photo-tag-entity>
              </div>
              <div class="row">
                <div v-for="player in entityOptions.awayTeam.players" :key="player.entity.entityUuid" class="col-lg-6">
                  <le-photo-tag-entity :entity="player.entity" :circle-info="player.jerseyNumber" :is-active="isEntitySelected(player.entity)" @entityClicked="toggleEntity(player.entity)"></le-photo-tag-entity>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { TokenService } from '@/services/storage.service'
import vue2Dropzone from 'vue2-dropzone'
import PhotoService from '@/services/photo.service'
import LePhotoTagEntity from '@/components/le/LePhotoTagEntity.vue'
import LeLoading from '@/components/le/LeLoading.vue'

export default {
  components: {
    LeLoading,
    LePhotoTagEntity,
    vueDropzone: vue2Dropzone
  },
  props: {
    gameUuid: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      rotatePhotoLoading: false,
      photoTagsLoading: false,
      isLoading: true,
      photos: [],
      entityOptions: null,
      currentPhotoIndex: 0,
      currentPhotoTags: []
    }
  },
  created () {
    this.removeFileTimers = []
  },
  beforeDestroy () {
    this.removeFileTimers.forEach(timer => clearTimeout(timer))
  },
  mounted () {
    this.getPhotos()
    this.getEntityOptions()
  },
  computed: {
    currentClient () {
      return this.$store.state.currentClient
    },
    currentPhoto () {
      return this.photos[this.currentPhotoIndex]
    },
    dropzoneOptions () {
      return {
        url: `${process.env.VUE_APP_BASE_URL}api/photos`,
        autoProcessQueue: true,
        uploadMultiple: false,
        parallelUploads: 1,
        maxFilesize: 50,
        addRemoveLinks: true,
        headers: {
          'X-ORGANISATION': this.currentClient.uuid,
          Authorization: `Bearer ${TokenService.getToken()}`,
          Accept: '*'
        }
      }
    }
  },
  methods: {
    async prevPhoto () {
      if (this.currentPhotoIndex > 0) {
        this.photoTagsLoading = true
        this.currentPhotoIndex--
        await this.getPhotoTags(this.currentPhoto)
        this.photoTagsLoading = false
      }
    },
    async nextPhoto () {
      if (this.currentPhotoIndex < this.photos.length - 1) {
        this.photoTagsLoading = true
        this.currentPhotoIndex++
        await this.getPhotoTags(this.currentPhoto)
        this.photoTagsLoading = false
      }
    },
    toggleEntity (entity) {
      const tagIndex = this.currentPhotoTags.findIndex(tag => tag.entityUuid === entity.entityUuid)

      if (tagIndex === -1) {
        PhotoService.addTag(this.currentPhoto.uuid, {
          entityUuid: entity.entityUuid,
          entityType: entity.entityType
        })

        this.currentPhotoTags.push({
          entityUuid: entity.entityUuid,
          entityType: entity.entityType
        })
      } else {
        PhotoService.deleteTag(this.currentPhoto.uuid, {
          entityUuid: entity.entityUuid,
          entityType: entity.entityType
        })

        this.currentPhotoTags.splice(tagIndex, 1)
      }
    },
    isEntitySelected (entity) {
      return this.currentPhotoTags.some(tag => tag.entityUuid === entity.entityUuid && tag.entityType === entity.entityType)
    },
    async editPhoto (photo, index) {
      this.photoTagsLoading = true
      this.currentPhotoIndex = index
      this.$modal.show('tags')
      await this.getPhotoTags(photo)
      this.photoTagsLoading = false
      window.addEventListener('keydown', this.onKeyPress)
    },
    modalClosed () {
      this.currentPhotoTags = []
      this.currentPhotoIndex = 0
      window.removeEventListener('keydown', this.onKeyPress)
    },
    onKeyPress (e) {
      if (e.code === 'ArrowLeft') {
        this.prevPhoto()
      } else if (e.code === 'ArrowRight') {
        this.nextPhoto()
      }
    },
    deletePhoto (photo, photoIndex) {
      PhotoService.delete(photo.uuid)
      this.photos.splice(photoIndex, 1)
    },
    toggleHighlight () {
      const photo = this.currentPhoto
      if (!photo || !photo.uuid) return
      const nextValue = !photo.isHighlighted
      if (this.$set) {
        this.$set(photo, 'isHighlighted', nextValue)
        // ensure array reactivity in some Vue versions
        this.$set(this.photos, this.currentPhotoIndex, { ...photo })
      } else {
        photo.isHighlighted = nextValue
        this.photos[this.currentPhotoIndex] = { ...photo }
      }

      PhotoService.updateIsHighlighted(photo.uuid, nextValue)
    },
    isHighlighted (photo) {
      if (!photo || !photo.uuid) return false
      return !!photo.isHighlighted
    },
    rotatePhoto (direction) {
      this.rotatePhotoLoading = true
      const photo = this.photos[this.currentPhotoIndex]
      PhotoService.rotate(photo.uuid, direction)
        .then(response => {
          this.photos[this.currentPhotoIndex] = response.data
          const photoElement = document.getElementById('photo-' + photo.uuid)
          const photoCoverElement = document.getElementById('photo-cover-' + photo.uuid)

          if (photoElement) {
            const url = new URL(photoElement.src)
            url.searchParams.set('v', Date.now())
            photoElement.src = url.toString()
          }

          if (photoCoverElement) {
            const url = new URL(photoCoverElement.src)
            url.searchParams.set('v', Date.now())
            photoCoverElement.src = url.toString()
          }
        }).finally(() => {
          this.rotatePhotoLoading = false
        })
    },
    async getPhotoTags (photo) {
      const response = await PhotoService.getTags(photo.uuid, 'game')
      this.currentPhotoTags = response.data
    },
    getEntityOptions () {
      PhotoService.getGameEntityOptions(this.gameUuid)
        .then(response => {
          this.entityOptions = response.data
        })
    },
    getPhotos () {
      this.isLoading = true
      PhotoService.index('game', this.gameUuid)
        .then(response => {
          this.photos = response.data
        })
        .catch(e => {
          console.log(e)
        }).finally(() => {
          this.isLoading = false
        })
    },
    moveUploadedFile (file, responseData) {
      // The page can be left within this second: the timers are cleared in beforeDestroy
      const timer = setTimeout(() => {
        this.removeFileTimers = this.removeFileTimers.filter(t => t !== timer)

        if (file.status === 'success') {
          this.photos.push(responseData)
        }

        if (this.$refs.dropzone) {
          this.$refs.dropzone.removeFile(file)
        }
      }, 1000)
      this.removeFileTimers.push(timer)
    },
    sendingEvent (file, xhr, formData) {
      formData.append('entityUuid', this.gameUuid)
      formData.append('entityType', 'game')
    }
  }
}
</script>

<style>
#dropzone-gallery {
  height: 270px;
  overflow: hidden;
  text-align: center;

  .dz-image img {
    object-fit: cover; /* Ensures images fit within the box */
  }

  .gallery-modal-header {
    background-color: #fff;
    position: sticky;
    top: 0;
    z-index: 2;
  }
}
.gallery-rotate-right-icon {
  transform: scaleX(-1)
}
</style>
